const state = {
    token: "",
    userId: "",
    userInfo: null
}

const mutations = {
    Mutation_SET_TOKEN(state, token) {
        state.token = token;
        localStorage.setItem("User_token", state.token);
    },
    Mutation_REMOVE_TOKEN(state) {
        state.token = "";
        localStorage.removeItem("User_token");
    },
    Mutation_SET_USERID(state, userId) {
        state.userId = userId;
    },
    SetUserInfo(state, userInfo) {
        state.userInfo = userInfo
        localStorage.setItem("User_userInfo_ZHS", JSON.stringify(state.userInfo));
    }
}

const actions = {

}

const getters = {
    token(state) {
        return state.token || localStorage.getItem('User_token');
    },
    userId(state) {
        return state.userId;
    },
    userInfo(state) {
        return state.userInfo || JSON.parse(localStorage.getItem('User_userInfo_ZHS'));
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}